import React from 'react';
import {Field, ErrorMessage } from 'formik';
import  {Box, Alert} from '@mui/material/';

function TextArea(props) {

    const { label, name } = props.symptom

    return (
        <Box sx={{border:"solid", borderColor:"grey.300",borderRadius:"10px", width:"auto", margin:1}}>
        <label htmlFor={name}> {label} </label><br></br>
        <Field as = 'textarea'className="textAreaInputBox"  id={name}  name={name}  />
        <ErrorMessage name={name} >
            {errorMsg => <Alert severity='error' >{errorMsg}</Alert>}
          </ErrorMessage>
        </Box>
     
     );
}

export default TextArea;
